/**
 * @param { Promise } promise
 * @param { Object= } errorExt - Additional Information you can pass to the err object
 * @return { Promise }
 */
export async function awaitToJS<T, U = Error> (
  promise: Promise<T>,
  errorExt?: object
): Promise<[U, undefined] | [null, T]> {
  try {
    const data: T = await promise;
    return [null, data];
  } catch (err) {
    if (errorExt) {
      const parsedError = Object.assign({}, err, errorExt);
      return [parsedError, undefined];
    }

    return [err, undefined];
  }
}

export default awaitToJS;
